import { render } from "./ReviewAuthorStarRounded16.vue?vue&type=template&id=321a9ea2"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__